var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMachineOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F3FBF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.45,
    y: 0.45,
    width: 23.1,
    height: 23.1,
    rx: 11.55,
    stroke: "#1AAD7F",
    strokeOpacity: 0.1,
    strokeWidth: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.0017C9.5 12.6368 8.98513 13.1517 8.35 13.1517C7.71487 13.1517 7.2 12.6368 7.2 12.0017C7.2 11.3666 7.71487 10.8517 8.35 10.8517C8.98513 10.8517 9.5 11.3666 9.5 12.0017Z",
    fill: "#1AAD7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31738 8.40723C9.63778 8.40723 10.791 9.13643 11.3965 10.2207L11.5244 10.4521H18.3027L19.6963 11.9697L17.4619 13.9355L16.25 13.127L16 12.9609L15.75 13.127L14.5225 13.9453L13.2793 12.9639L13.1562 12.8662H11.7441L11.6367 13.1641C11.145 14.5322 9.84286 15.5068 8.31738 15.5068C6.37091 15.5068 4.78906 13.9199 4.78906 11.957C4.78906 9.99414 6.37091 8.40724 8.31738 8.40723Z",
    stroke: "#1AAD7F",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineOn);
export default __webpack_public_path__ + "static/media/machine_on.333c365bb4a4ffce685311b139c30c3a.svg";
export { ForwardRef as ReactComponent };